<template>
  <table class="browse-table table table-hover table-container change_table_color">
    <thead>
    <tr>
      <th scope="col" class="text-uppercase">{{ $t('email') }}</th>
      <th>{{ $t('type') }}</th>
      <th>{{ $t('added') }}</th>
      <th>{{ $t('action') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr class="edit-hover" v-for="email in emails" :key="email.id">
      <td><span>{{ email.email }}</span></td>
      <td><span>{{ $t(email.type) }}</span></td>
      <td><span>{{ email.created_at }}</span></td>
      <td>
        <button
            class="btn btn-link delete-email"
            @click="$emit('delete', email)"
            :class="{ 'is-disabled': email.is_deleting }"
            :title="email.is_deleting ? 'Deletion in progress...' : ''">
          {{ $t('delete') }}
        </button>
        <button
            v-if="email.type === 'other'"
            class="btn btn-link edit-email"
            @click="$emit('edit', email.id)">
          {{ $t('edit') }}
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['emails']
};
</script>

<style scoped>
/* Add some basic styling for the disabled button */
.is-disabled {
  color: #ccc;
  cursor: not-allowed !important;  /* Disable cursor */
}
</style>